module.exports = __webpack_public_path__ + "static/media/undraw_book_lover_mkck.e9b358f1.svg";